export default __webpack_public_path__ + "static/media/12.3f062ce9.webp";